module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    attrs: {
      "fixed": "",
      "app": "",
      "clipped-left": "",
      "dark": "",
      "color": "black"
    }
  }, [(_vm.authenticated) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleDrawer($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', [_c('router-link', {
    staticClass: "d-flex white--text",
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": '/static/assets/' + _vm.siteSettings.logo,
      "height": "48px"
    }
  })])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.authenticated) ? [_c('progress-bar', {
    attrs: {
      "show": _vm.busy
    }
  }), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "text-xs-center hidden-xs-only"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "mr-1"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("arrow_drop_down")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.$t('logout')))])], 1)], 1)], 1)], 1)] : [_c('v-toolbar-items', {
    staticClass: "hidden-xs-only"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('login')))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('register')))])], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d765de9c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToolBar.vue
// module id = AQmQ
// module chunks = 1